import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'
import { type ITabItem } from 'shared/ui'
import { type ISendFromInfo } from 'entities/SendFrom/api/type'
import { fetchSendFromInfo } from 'entities/SendFrom/lib/getSendFromInfo'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SurveysApi } from 'entities/Surveys'
import { type IResponseFullSurvey } from 'entities/Surveys/api/types'

export type IDetailsSurveyTabKey =
  | 'contactEnrollment'
  | 'scoreElaboration'
  | 'closingMessage'
  | 'actions'

export class DetailsSurveyModalStore {
  loading = true
  private _data: IResponseFullSurvey | null = null
  sendFromInfo: ISendFromInfo | null = null
  activeTabKey: IDetailsSurveyTabKey = 'contactEnrollment'

  constructor(private _surveyId: number, readonly entities: IEntitiesStore) {
    makeAutoObservable(this)
    void this._init()
  }

  get tabs(): ITabItem<IDetailsSurveyTabKey>[] {
    return [
      { key: 'contactEnrollment', name: 'Contact enrollment' },
      { key: 'scoreElaboration', name: 'Score elaboration' },
      { key: 'closingMessage', name: 'Closing message' },
      { key: 'actions', name: 'Actions' },
    ]
  }

  get npsQuestion() {
    const company = this._data?.question?.company_name?.trim() ?? 'company or product name'
    return `How likely are you to recommend '${company}' to your friends or colleagues? From 0 (not likely) to 10 (very likely)`
  }

  get contactsCount() {
    return this._data?.total_contacts_count ?? 0
  }

  setActiveTab = (tab: ITabItem<IDetailsSurveyTabKey>) => {
    this.activeTabKey = tab.key
  }

  private _init = async () => {
    try {
      const { data } = await SurveysApi.getSurvey(this._surveyId)
      runInAction(() => {
        this._data = data
      })

      if (data.send_from) {
        const info = await fetchSendFromInfo(data.send_from, this.entities)
        runInAction(() => {
          this.sendFromInfo = info
        })
      }
    } catch (e) {
      logger.error(e)
    } finally {
      runInAction(() => {
        this.loading = false
      })
    }
  }
}
